import { render, staticRenderFns } from "./confirm-logout.vue?vue&type=template&id=6a06128c"
import script from "./confirm-logout.vue?vue&type=script&lang=js"
export * from "./confirm-logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports